<!-- Trigger: zeigt die aktuelle Punktart, oeffnet den Auswahl-Dialog. -->
<button type="button" class="form-control punktart-trigger" (click)="open()">
	<ng-container *ngIf="hasSelection; else placeholder">
		<img *ngIf="!currentBadge" [src]="currentSvgUrl" class="trigger-icon" alt="">
		<span *ngIf="currentBadge" class="symbol-badge" [style.color]="currentColor">{{ currentBadge }}</span>
		<span class="trigger-nr">Nr.&nbsp;{{ currentNummer }}</span>
		<span class="trigger-text">{{ currentBeschreibung }}</span>
	</ng-container>
	<ng-template #placeholder>
		<span class="text-muted">Punktart wählen …</span>
	</ng-template>
	<i class="bi bi-chevron-down ms-auto text-secondary"></i>
</button>

<ng-template #pickerModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Punktart wählen</h5>
		<button type="button" class="btn-close" aria-label="Schließen" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body p-2">
		<div class="search-wrap mb-2">
			<i class="bi bi-search search-icon"></i>
			<input type="text" class="form-control" placeholder="Suchen oder Nummer tippen …"
				[(ngModel)]="query" autocomplete="off" [attr.ngbAutofocus]="autofocusSearch ? '' : null">
		</div>

		<!-- Suche aktiv: flache, kompakte Trefferliste. -->
		<ng-container *ngIf="searching; else browse">
			<div class="picker-grid">
				<button *ngFor="let r of filtered" type="button" class="picker-tile"
					[class.is-current]="r.nummer === currentNummer"
					(click)="choose(r.nummer)" [title]="r.beschreibung">
					<img *ngIf="!r.invisible" [src]="r.svgUrl" class="tile-icon" alt="">
					<span *ngIf="r.invisible" class="symbol-badge" [style.color]="r.color">{{ r.badge }}</span>
					<span class="tile-nr">{{ r.nummer }}</span>
					<span class="tile-text">{{ r.beschreibung }}</span>
				</button>
			</div>
			<div *ngIf="filtered.length === 0" class="text-muted text-center p-3">Keine Treffer</div>
		</ng-container>

		<!-- Browse: Favoriten + nach Kategorie gruppiert. -->
		<ng-template #browse>
			<ng-container *ngIf="favoritenRows.length">
				<h6 class="picker-section">Häufig verwendet</h6>
				<div class="picker-grid">
					<button *ngFor="let r of favoritenRows" type="button" class="picker-tile"
						[class.is-current]="r.nummer === currentNummer"
						(click)="choose(r.nummer)" [title]="r.beschreibung">
						<img *ngIf="!r.invisible" [src]="r.svgUrl" class="tile-icon" alt="">
						<span *ngIf="r.invisible" class="symbol-badge" [style.color]="r.color">{{ r.badge }}</span>
						<span class="tile-nr">{{ r.nummer }}</span>
						<span class="tile-text">{{ r.beschreibung }}</span>
					</button>
				</div>
			</ng-container>

			<ng-container *ngFor="let g of groups">
				<h6 class="picker-section">{{ g.kategorie }}</h6>
				<div class="picker-grid">
					<button *ngFor="let r of g.rows" type="button" class="picker-tile"
						[class.is-current]="r.nummer === currentNummer"
						(click)="choose(r.nummer)" [title]="r.beschreibung">
						<img *ngIf="!r.invisible" [src]="r.svgUrl" class="tile-icon" alt="">
						<span *ngIf="r.invisible" class="symbol-badge" [style.color]="r.color">{{ r.badge }}</span>
						<span class="tile-nr">{{ r.nummer }}</span>
						<span class="tile-text">{{ r.beschreibung }}</span>
					</button>
				</div>
			</ng-container>
		</ng-template>
	</div>
</ng-template>
